import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { TextFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkTextPOSTErrorResponse, ParkTextPOSTRequest, ParkTextPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const sendByText = async (requestData: ParkTextPOSTRequest): Promise<ParkTextPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkTextPOSTSuccessResponse>("/text", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkTextPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: TextFailReason };
  }
};
